<template>
  <layout :title="$route.name">
    <Form class="pa-3" />
    <!-- <MainAddress class="pa-3" v-if="tabs === 1" /> -->
    <MainAccountBank class="pa-3" v-if="tabs === 1" />
    <ModalViewAddress />
    <v-card class="pa-3 mt-3">
      <v-card-title class="error--text">Excluir conta</v-card-title>
      <v-card-text>
        Esta ação é irreversível. Sua conta será excluída e você não poderá mais acessá-la.
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" outlined @click="dialogDeleteAccount = true">
          Excluir minha conta
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogDeleteAccount" max-width="400">
      <v-card>
        <v-card-title>Confirmar exclusão</v-card-title>
        <v-card-text>
          Tem certeza que deseja excluir sua conta? Essa ação não pode ser desfeita.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDeleteAccount = false">Cancelar</v-btn>
          <v-btn color="error" @click="confirmDeleteAccount">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Form from "./components/PhotoPass";
import MainAddress from "@/apps/9#addresses/Main";
import MainAccountBank from "./components/MainAccountBank";
import ModalViewAddress from "@/apps/9#addresses/components/ModalViewAddress";
export default {
  data() {
    return {
      tabs: 0,
      dialogDeleteAccount: false
    };
  },
  components: {
    Form,
    MainAddress,
    ModalViewAddress,
    MainAccountBank
  },
  computed: {
    ...mapGetters(["getLoggedUser"])
  },
  methods: {
    ...mapActions(["deleteAccount"]),
    confirmDeleteAccount() {
      this.dialogDeleteAccount = false;
      this.deleteAccount();
    }
  }
};
</script>
